// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kSeRk","label":"styles_label__2QzoZ"};